import { captureException } from '@sentry/nextjs';
import axios, { AxiosError, AxiosResponse } from 'axios';

import { getApiUrl } from '../utils/urlUtil';

const instance = axios.create({
  baseURL: CONFIG.apiUrl,
});

instance.interceptors.request.use((requestConfig) => {
  // Re-resolve per request rather than at create() time — the module can
  // be evaluated during SSR where window (and thus the Coder port-forward
  // host detection) isn't available yet.
  requestConfig.baseURL = getApiUrl();
  if (CONFIG.cfAccessClientId && CONFIG.cfAccessClientSecret) {
    requestConfig.headers['CF-Access-Client-Id'] = CONFIG.cfAccessClientId;
    requestConfig.headers['CF-Access-Client-Secret'] = CONFIG.cfAccessClientSecret;
  }
  return requestConfig;
});

instance.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    captureException(error);
    return Promise.reject(error);
  }
);

export default instance;
